import { useMemo } from 'react';

export const useInlineMemo = (styles: any, deps: any[] = []) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => styles, deps);
